import { useParams } from 'react-router-dom';
import { MEET_ID_KEY } from '../lib/constants';

export function useMeetingId(): string {
  return useParams<{[ MEET_ID_KEY ]: string}>()[MEET_ID_KEY];
}
